import { useSyncExternalStore } from "react";

export interface BlogTransitionData {
	slug: string;
	coverImage: string;
	cardRect: DOMRect;
}

let transitionData: BlogTransitionData | null = null;
const listeners = new Set<() => void>();

function notify() {
	for (const listener of listeners) {
		listener();
	}
}

export function setTransition(data: BlogTransitionData) {
	transitionData = data;
	notify();
}

export function clearTransition() {
	transitionData = null;
	notify();
}

function getSnapshot() {
	return transitionData;
}

function subscribe(listener: () => void) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function useBlogTransition() {
	return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
